type ReportMessageProps = {
  message: string | undefined;
};

const ReportMessage = ({ message }: ReportMessageProps) => {
  return message && <div className="mt-4 font-bold text-green-700">{message}</div>;
};

export default ReportMessage;
